/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'arrow-circle': {
    width: 45,
    height: 45,
    viewBox: '0 0 45 45',
    data: `<defs><clipPath id="svgicon_arrow-circle_a"><path pid="0" d="M0 0h45v45H0z"/></clipPath></defs><g clip-path="url(#svgicon_arrow-circle_a)"><path pid="1" d="M22.5.5a22 22 0 11-22 22 22 22 0 0122-22zm12.225 27.176L22.5 15.451 10.272 27.676" _fill="none" _stroke="currentColor" stroke-width="1.5"/></g>`
  }
})
/* tslint:enable */
